import { CSProductDetails } from '@websrc/Typings/ContentStack'
import React from 'react'

import { table } from './ComparisonTable.css'
import { ComparisonTableProductHeading } from './ComparisonTableProductHeading'
import { ComparisonTableProductImage } from './ComparisonTableProductImage'
import { ComparisonTableProductPageLink } from './ComparisonTableProductPageLink'
import { ComparisonTableProductPrice } from './ComparisonTableProductPrice'
import { ComparisonTableSelectTr } from './ComparisonTableSelectTr'
import { isCellVisible } from './ComparisonTableUtils'

interface ComparisonTableNotStickyTheadProps {
  isMobile: boolean
  products: CSProductDetails[]
  setVisibleProductIndex: React.Dispatch<React.SetStateAction<number>>
  visibleProductIndex: number
}

export function ComparisonTableNotStickyThead({
  isMobile,
  products,
  setVisibleProductIndex,
  visibleProductIndex,
}: ComparisonTableNotStickyTheadProps) {
  return (
    <thead className={table.thead.notSticky._}>
      <ComparisonTableSelectTr
        isMobile={isMobile}
        products={products}
        setVisibleProductIndex={setVisibleProductIndex}
      />
      <tr>
        <th> </th>
        {products.map(
          (product, i) =>
            isCellVisible(i, visibleProductIndex, isMobile) && (
              <th className={table.thead.notSticky.th} key={i}>
                <ComparisonTableProductImage isSticky={false} product={product} />
              </th>
            )
        )}
      </tr>
      <tr>
        <th> </th>
        {products.map(
          (product, i) =>
            isCellVisible(i, visibleProductIndex, isMobile) && (
              <th className={table.thead.notSticky.th} key={i}>
                <ComparisonTableProductHeading isSticky={false} product={product} />
              </th>
            )
        )}
      </tr>
      <tr>
        <th> </th>
        {products.map(
          (product, i) =>
            isCellVisible(i, visibleProductIndex, isMobile) && (
              <th className={table.thead.notSticky.ctaTh} key={i}>
                <ComparisonTableProductPrice
                  className={table.thead.notSticky.price}
                  product={product}
                />
                <ComparisonTableProductPageLink product={product} />
              </th>
            )
        )}
      </tr>
    </thead>
  )
}
